import { Link } from "react-router-dom";
import { Languages } from "lucide-react";
import { PAIRS } from "@/lib/languages";

const POPULAR_PAIRS = PAIRS.slice(0, 6);

const FLink = ({ to, children, testId }) => (
  <Link
    to={to}
    data-testid={testId}
    className="text-sm text-zinc-400 hover:text-white transition-colors"
  >
    {children}
  </Link>
);

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-zinc-950 text-zinc-300 mt-16 border-t border-zinc-800/60"
    >
      <div className="container-x py-10 lg:py-12">
        {/* Top row: brand + nav links */}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <Link to="/" className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center bg-primary text-primary-foreground rounded-md">
              <Languages className="h-4 w-4" strokeWidth={1.75} />
            </span>
            <span className="font-display font-black text-lg tracking-tighter text-white">
              Tiny<span className="text-primary"> Stem</span>
            </span>
          </Link>

          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2" data-testid="footer-col-company">
            <FLink to="/" testId="footer-home">Home</FLink>
            <FLink to="/about" testId="footer-about">About</FLink>
            <FLink to="/contact" testId="footer-contact">Contact</FLink>
            <FLink to="/privacy" testId="footer-privacy">Privacy</FLink>
            <FLink to="/terms" testId="footer-terms">Terms</FLink>
          </nav>
        </div>

        {/* Translation links — compact grid */}
        <div className="mt-8 pt-6 border-t border-zinc-800/50" data-testid="footer-col-translations">
          <p className="text-xs uppercase tracking-wider text-zinc-500 mb-3">Popular translations</p>
          <div className="flex flex-wrap gap-x-5 gap-y-2">
            {POPULAR_PAIRS.map((p) => (
              <FLink key={p.slug} to={`/${p.slug}`} testId={`footer-lang-${p.slug}`}>
                {p.keyword.replace(" Translation", "")}
              </FLink>
            ))}
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 pt-6 border-t border-zinc-800/50 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
          <p className="text-xs text-zinc-500" data-testid="footer-copyright">
            © {new Date().getFullYear()} tinystem.com
          </p>
          <p className="text-xs text-zinc-500">
            Fast, accurate translations for every language.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
